export class UpdateUserRequest { 
    
    public idRol : number=0;
    
}
    